import app from 'flarum/forum/app';
import { slug } from '../../common';
//import HomeDiscussions from 'flarum/core/forum/components/HomeDiscussions';
//import HomeDiscussions from 'flarum/forum/components/HomeDiscussions';
import HomeDiscussions from './HomeDiscussions';

import DiscussionListItem from 'flarum/components/DiscussionListItem';
//import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.frontpage`;

const randomStr = Math.pow(Math.random() + 10, 100).toString(36);

export default class HomeFeatured extends HomeDiscussions {
	get preloadedKey() {
		return this.attrs.preloadedKey ? this.attrs.preloadedKey : 'featured';
	}

	get defaultParams() {
		const { params } = this.attrs;
		const defaultParams = { filter: { frontpage: true }, sort: '-frontdate' };
		return {
			...defaultParams,
			...params,
		};
	}

	get limit() {
		return 2;
	}

	get titleText() {
		// You may need to adjust this line according to your translation configuration.
		return t(`${prfx}.title`);
        //return 'Featured Discussions';
	}

	listItem(discussion) {
		return (
			<li key={discussion.id()} data-id={discussion.id()}>
				<DiscussionListItem
					discussion={discussion}
					params={{
						// When passing `q` the excerpt is shown
						q: randomStr, // Random string to avoid highlights
					}}
				/>
			</li>
		);
	}
}
